// extracted by mini-css-extract-plugin
module.exports = {"title":"departuresPage_title__l4niu","search":"departuresPage_search__m41DG","table":"departuresPage_table__FDHUM","list":"departuresPage_list__aSYme"};